import { Raw } from './gb-raw';
riot.tag2('gb-raw', '<span></span>', '', '', function(opts) {
    this._mixin(Raw);
});



/** WEBPACK FOOTER **
 ** ./src/tags/raw/gb-raw.tag.html
 **/